import 'slick-carousel';

class slider {
    constructor() {
        this.sliderInit();
    }

    sliderInit() {
        if ($(".slider-01").length) {
            $(".slider-01").each((num, elm) => {
                elm = $(elm);
                if (elm.hasClass("slick-initialized")) {
                    elm.slick("unslick");
                }
                elm.slick(this.slickopts());

            });
        }
        if ($(".slider-02, .slider-04, .slider-05").length) {
            $(".slider-02, .slider-04, .slider-05").each((num, elm) => {
                elm = $(elm);
                if (elm.hasClass("slick-initialized")) {
                    elm.slick("unslick");
                }
                elm.slick(this.slicktwoopts());

            });
        }
        if ($(".slider-06").length) {
            $(".slider-06").each((num, elm) => {
                elm = $(elm);
                if (elm.hasClass("slick-initialized")) {
                    elm.slick("unslick");
                }
                elm.slick(this.slicktwooptsSlider06());

            });
        }
        // Show Slider 03 After Bootstrap Modal Load
        $('.modal').on('shown.bs.modal', function (e) {
            $('.slider-wrapper').addClass('open');
            // Nanoscroller JS
            $(".nano").nanoScroller({
                scroll: 'top',
                alwaysVisible: true
            });
            $('.slider-03').slick('setPosition');
        });

        if ($(".slider-03").length) {
            $(".slider-03").each((num, elm) => {
                elm = $(elm);
                if (elm.hasClass("slick-initialized")) {
                    elm.slick("unslick");
                }
                elm.slick(this.slickthreeopts());
                $('.popup-lead-hikers').on('click', (e) => {
                    e.preventDefault();
                    var elem = $(e.currentTarget);
                    var slideno = elem.attr('data-id');
                    $('#leadHikers').modal('show');
                    elm.slick('slickGoTo', slideno);

                })
                $(".slider-03").on("beforeChange", function (event, slick) {
                    var currentSlide, slideType, player, command;
                    currentSlide = $(slick.$slider).find(".slick-current");
                    // slideType = currentSlide.attr("class").split(" ")[1];
                    player = currentSlide.find("iframe").get(0);

                    // if (slideType == "vimeo") {
                    command = {
                        "method": "pause",
                        "value": "true"
                    };
                    //check if the player exists.
                    if (player != undefined) {
                        //post our command to the iframe.
                        player.contentWindow.postMessage(JSON.stringify(command), "*");
                    }
                });

            });


        }

    }

    slicktwooptsSlider06() {
        return {
            dots: true,
            arrows: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            fade: true,
            autoplay: true,
            autoplaySpeed: 5000,
            customPaging: function (slick, index) {
                return '<a class="circle-dots"></a>';
            }
        }
    };

    slicktwoopts() {
        return {
            dots: false,
            arrows: false,
            slidesToShow: 3,
            slidesToScroll: 1,
            margin: 24,
            customPaging: function (slick, index) {
                return '<a class="circle-dots"></a>';
            },
            responsive: [
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 3
                    }
                },
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 1,
                        dots: true,
                    }
                }]
        }
    }

    slickopts() {
        return {
            dots: true,
            arrows: false,
            slidesToShow: 5,
            slidesToScroll: 5,
            rows: 2,
            customPaging: function (slick, index) {
                return '<a class="circle-dots"></a>';
            },
            responsive: [
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 3
                    }
                },
                {
                    breakpoint: 767,
                    settings: {
                        rows: 5,
                        slidesToShow: 2,
                        slidesToScroll: 2
                    }
                }]
        }
    }

    slickthreeopts() {
        return {
            dots: false,
            prevArrow: '<a href="javascript:void(0);" class="slide-arrow prev-arrow"><img src="' + hiker_object.template_url + '/dist/images/arrow-left@2x.png"></a>',
            nextArrow: '<a href="javascript:void(0);" class="slide-arrow next-arrow"><img src="' + hiker_object.template_url + '/dist/images/arrow-right@2x.png"></a>',
            responsive: [
                {
                    breakpoint: 767,
                    settings: {
                        arrow: false,
                    }
                }]
        }
    }

}


export default slider;

